import { keyMirror } from 'utils/keyMirror';

export const ActionTypes = keyMirror(
  {
    ADD_SCREEN: null,
  },
  'AddScreen',
);
